import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link, useParams } from 'react-router-dom';
import DisplayChecklistDetail from './DisplayChecklistDetail';

type RouteChecklistDetailParams = {
  checklistID: string;
}

const RouteChecklistDetail = () => {
  let { checklistID } = useParams<keyof RouteChecklistDetailParams>() as RouteChecklistDetailParams;
  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to={`/checklist/${checklistID}/edit`}>
            <Button>Edit</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <DisplayChecklistDetail checklistID={checklistID} />
        </Col>
      </Row>
    </>
  );
};

export default RouteChecklistDetail;
